import { useEffect, useRef, useState } from "react";
import { MapPin, Loader2, Plane } from "lucide-react";
import { fetchAutocomplete } from "../../lib/booking";

export const AddressAutocomplete = ({ value, onSelect, placeholder, testid, label }) => {
  const [q, setQ] = useState(value?.description || "");
  const [items, setItems] = useState([]);
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const boxRef = useRef(null);

  useEffect(() => {
    setQ(value?.description || "");
  }, [value]);

  useEffect(() => {
    if (!q || q.length < 2) {
      setItems([]);
      return;
    }
    if (value && q === value.description) return;
    const t = setTimeout(async () => {
      setLoading(true);
      try {
        const s = await fetchAutocomplete(q);
        setItems(s);
        setOpen(true);
      } catch {
        setItems([]);
      } finally {
        setLoading(false);
      }
    }, 250);
    return () => clearTimeout(t);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [q]);

  useEffect(() => {
    const h = (e) => {
      if (boxRef.current && !boxRef.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener("mousedown", h);
    return () => document.removeEventListener("mousedown", h);
  }, []);

  const choose = (it) => {
    onSelect(it);
    setQ(it.description);
    setItems([]);
    setOpen(false);
  };

  return (
    <div className="relative" ref={boxRef}>
      {label && (
        <label className="mb-1.5 block text-[0.72rem] font-medium tracking-wide text-ink">{label}</label>
      )}
      <div className="relative">
        <MapPin size={16} className="pointer-events-none absolute left-3 top-1/2 -translate-y-1/2 text-ink/70" />
        <input
          value={q}
          onChange={(e) => {
            setQ(e.target.value);
            if (value) onSelect(null);
          }}
          onFocus={() => items.length && setOpen(true)}
          placeholder={placeholder}
          data-testid={testid}
          autoComplete="off"
          className="w-full rounded-xl border border-ink/10 bg-ink/[0.035] py-3 pl-9 pr-9 text-sm text-ink placeholder:text-ink/55 transition-colors focus:border-gold/70 focus:bg-white focus:outline-none"
        />
        {loading && (
          <Loader2 size={15} className="absolute right-3 top-1/2 -translate-y-1/2 animate-spin text-ink/70" />
        )}
      </div>
      {open && items.length > 0 && (
        <ul
          className="absolute z-50 mt-1.5 max-h-60 w-full overflow-auto rounded-xl border border-ink/10 bg-white shadow-xl shadow-ink/10"
          data-testid={`${testid}-suggestions`}
        >
          {items.map((it) => (
            <li key={it.id}>
              <button
                type="button"
                onClick={() => choose(it)}
                data-testid={`${testid}-option`}
                className="flex w-full items-start gap-2.5 px-3.5 py-2.5 text-left text-sm text-ink/80 transition-colors hover:bg-gold/10"
              >
                {it.is_airport ? (
                  <Plane size={15} className="mt-0.5 shrink-0 text-gold" />
                ) : (
                  <MapPin size={15} className="mt-0.5 shrink-0 text-ink/70" />
                )}
                <span>{it.description}</span>
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};
